import React from 'react';

const ProductoCustom = ({producto}) => {
	return(
		<div className="customBanner">
			<h4 className="h2-alt font-french-pass">Diseña tu producto.</h4>
			<a className="btn btn-white add-margin" href="">Personalizalo!!</a>
		</div>
		)
}

export default ProductoCustom;



// WEBPACK FOOTER //
// ./src/components/productocustom.js